import type { FaireProductEntity } from "../../entity_types/product";

export const p_58yfp9w6qm: FaireProductEntity = {
  token: "p_58yfp9w6qm",
  type: "product",
  name: "I ❤️ Caviar Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/9f7916949f3d22a22cb9a2a7bd5960c28e8bc817511881da80dc6c3d70599bc1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/af9f39e07d0c0d505f8cbe4e547c6ff351a2a92453489a5c4075a24e938ccd29.jpeg",
    "https://cdn.faire.com/fastly/6d2a6a6cea72d0a117811afc0045a14df5001e78561ba1f38713ed81bfa1905e.jpeg",
    "https://cdn.faire.com/fastly/391c5ce5ab59bd650a6891bed7080c0c4dc2d9b1ce982c89cc5843ec8e043e9b.jpeg",
    "https://cdn.faire.com/fastly/87121b429b961654891fab34f30ff92006b404047871e802f53ac2eada022384.jpeg",
    "https://cdn.faire.com/fastly/fad3842457badc4cdac5d943757ae00942844c78d191b19cf79e8342b0b39497.jpeg"
  ],
  priceDollars: 6.75,
  description: "A little bump never hurt anybody, right? Nothing says \"I'm fancy\" like socks that celebrate tiny salty fish eggs. \n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance.\n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:30:59.262Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
